import { Connection } from './connection';
import { Entity } from './entity';

export interface ReadOnlyManyOf<T> {
  readonly record: Record<string, T>;
  readonly list: Array<T>;
}

export class ManyOf<T extends Entity> implements ReadOnlyManyOf<T>, Connection {
  public record: Record<string, T> = {};
  public list: T[] = [];
  public connectionId: string | null = null;

  public add(element: T) {
    if (element.id in this.record) {
      return;
    }

    this.record[element.id] = element;
    this.list.push(element);
  }

  public remove(element: T) {
    if (!(element.id in this.record)) {
      return;
    }

    delete this.record[element.id];
    this.list.removeMatching((e) => e.id === element.id);
  }

  public addMultiple(elements: T[]) {
    for (const element of elements) {
      this.add(element);
    }
  }

  public removeMultiple(elements: T[]) {
    for (const element of elements) {
      this.remove(element);
    }
  }

  public clear() {
    // @ts-ignore
    this.record = {};
    // @ts-ignore
    this.list = [];
  }
}
